import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import styled from 'styled-components';
import Checkbox from '@zocdoc-frontend-common/components-checkbox';
import { Link } from '@zocdoc-frontend-common/components-link';
import { Column } from '@zocdoc-frontend-common/styles-grid';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import Row from '@zocdoc-frontend-common/styles-grid/components/Row';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { rememberMeField } from '../../../constants';

const anchors = {
    terms: '/about/terms',
    privacy: '/about/privacypolicy',
};

/**
 * @param {boolean} error
 * @param {function(): void} onChange
 * @param {function(): void} onView
 * @param {boolean} showRememberMe
 * @returns {JSX.Element}
 * @constructor
 */
export default class TermsAndPrivacy extends Component {
    render() {
        const { onView, onChange, error } = this.props;

        return (
            <CheckboxFormRow>
                <Row>
                    <TermsAndPrivacyWrapper>
                        <VisibilitySensor
                            onChange={() => onView('termsOfService')}
                        >
                            <FlushCheckbox
                                data-test="terms-and-privacy-checkbox"
                                data-uem-id="terms-and-privacy-checkbox"
                                iconStyle={{ marginLeft: '0' }}
                                invalidMessage={
                                    error
                                        ? 'Please read and accept the Terms of Use and Privacy Policy.'
                                        : undefined
                                }
                                onChange={(e) =>
                                    onChange('termsOfService', e.target.checked)
                                }
                            >
                                <CheckboxLabel>
                                    {`I have read and accept Zocdoc's `}
                                    <Link
                                        data-test="terms"
                                        href={anchors.terms}
                                        target="_blank"
                                    >
                                        Terms of Use
                                    </Link>
                                    {' and '}
                                    <Link
                                        data-test="privacy"
                                        href={anchors.privacy}
                                        target="_blank"
                                    >
                                        Privacy Policy
                                    </Link>
                                    .
                                </CheckboxLabel>
                            </FlushCheckbox>
                        </VisibilitySensor>

                        {this.maybeRenderRememberMe()}
                    </TermsAndPrivacyWrapper>
                </Row>
            </CheckboxFormRow>
        );
    }

    maybeRenderRememberMe() {
        const { onChange, showRememberMe } = this.props;

        if (showRememberMe) {
            return (
                <FlushCheckbox
                    data-test="remember-me-checkbox"
                    data-uem-id="remember-me-checkbox"
                    iconStyle={{ marginLeft: '0' }}
                    onChange={(e) =>
                        onChange(rememberMeField, e.target.checked)
                    }
                    checked
                >
                    Keep me signed in
                </FlushCheckbox>
            );
        }
    }
}

const CheckboxFormRow = styled(FormRow)`
    margin-bottom: 44px;
`;
const FlushCheckbox = styled(Checkbox)`
    padding-left: 0;
`;
const CheckboxLabel = styled.div`
    color: ${blue100};
    font: 16px/1.333 ${FontFamily.SharpSansMedium};
    padding-top: 1px;
    padding-bottom: 3px;
`;
const TermsAndPrivacyWrapper = styled(Column)`
    & > div {
        margin-bottom: 16px;
    }
    & > :last-child {
        margin-bottom: 0px;
    }
`;
